/**
 * 广告管理相关
 * 接口地址http://gitlab.10niu.cn/repository/editor?id=21&mod=541&itf=3605
 * 原型https://ydreyn.axshare.com/#g=1&p=home
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';
/* 
 广告配置 
 */
const configurationAd = {
	// 获取oem列表
	getOemList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/advertisement/oem_list`,
			headers: config.headers,
			params
		});
	},
	// 改变渠道商广告配置状态
	changeAdvertisementStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/advertisement/change_advertisement_status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取代理商列表
	getAgentList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/advertisement/agent_list`,
			headers: config.headers,
			params
		});
	},
	// 编辑代理商广告配置状态
	editAgentAdvertisementStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/advertisement/edit_agent_advertisement_status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取学校列表
	getSchoolList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/advertisement/school_list`,
			headers: config.headers,
			params
		});
	},
	// 编辑学校广告配置状态
	editSchoolAdvertisementStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/advertisement/edit_school_advertisement_status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default configurationAd;
